/* Integrate the supplied BrainParticles bundle with the Insights hero lifecycle. */
(function () {
  'use strict';
  if (window.mnlInsBrainLoaded) return;
  window.mnlInsBrainLoaded = true;
  function init(root) {
    root.querySelectorAll('[data-mnl-brain-hero]').forEach(function (scene) {
      var canvas = scene.querySelector('[data-mnl-brain-canvas]');
      if (!canvas || canvas.__brain || !window.BrainParticles) return;
      var brain = window.BrainParticles(canvas, { src: canvas.dataset.src, zoom: 0.8 });
      canvas.__brain = brain;
      var disposed = false;
      function visibility() { brain[document.hidden ? 'pause' : 'play'](); }
      document.addEventListener('visibilitychange', visibility);
      visibility();
      brain.ready.then(function (ready) {
        if (ready && !disposed) scene.classList.add('is-brain-ready');
      });
      (scene.closest('.shopify-section') || scene).addEventListener('shopify:section:unload', function () {
        disposed = true;
        document.removeEventListener('visibilitychange', visibility);
        brain.destroy();
        delete canvas.__brain;
      }, { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
